import { Link } from '@material-ui/core'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useDeleteAbundanceEngineView } from '../../../../../api/abundanceEngine'
import SydButton from '../../../../commonDesign/Button'
import SydModal from '../../../../commonDesign/SydModal'
import SydModalActions from '../../../../commonDesign/SydModal/SydModalActions'

const ViewActionsCell = ({ path, viewId, onDeleted }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const { mutate, isLoading, isSuccess } = useDeleteAbundanceEngineView()

  const handleOnDelete = useCallback(() => {
    mutate(viewId)
  }, [mutate, viewId])

  useEffect(() => {
    if (isSuccess) {
      setShowDeleteConfirm(false)
      onDeleted?.()
    }
  }, [isSuccess, onDeleted])

  return (
    <div className='flex gap-2'>
      <Link
        href={'/admin/abundance-engine-views/edit/' + path}
      >
        <SydButton size='sm' icon='edit' variant='primary'>
          Edit
        </SydButton>
      </Link>

      <Link href={`/views/${path}`} target='_blank'>
        <SydButton size='sm' icon='goToDocument'>
          Go to view
        </SydButton>
      </Link>

      <SydButton
        size='sm'
        icon='delete'
        variant='primary'
        priority='warning'
        onClick={() => setShowDeleteConfirm(true)}
      >
        Delete
      </SydButton>

      <SydModal
        disablePortal={false}
        title='Delete this view?'
        subtitle='This action cannot be undone.'
        open={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
      >
        <SydModalActions>
          <SydButton
            onClick={() => setShowDeleteConfirm(false)}
            variant='outline'
            processing={isLoading}
          >
            Cancel
          </SydButton>
          <SydButton
            onClick={handleOnDelete}
            variant='primary'
            priority='warning'
            processing={isLoading}
          >
            Delete
          </SydButton>
        </SydModalActions>
      </SydModal>
    </div>
  )
}

ViewActionsCell.propTypes = {
  path: PropTypes.string,
  viewId: PropTypes.number,
  onDeleted: PropTypes.func
}

export default ViewActionsCell
